import "./styles.css";
import { useState } from "react";
import { Col, Row } from "antd";
import VehicleAnalyticsMenu from "./VehicleAnalyticsMenu";
import PageLayout from "./PageLayout";

const menuOptions = [
  {
    label: 'Vehicle Analytics',
    value: 'analytics',
  },
  {
    label: 'Data Dashboard',
    value: 'data',
  },
  {
    label: 'Real Time Dashboard',
    value: 'realtime',
  },
];

const VehicleAnalytics = () => {
  const [selectedMenu, setSelectedMenu] = useState(menuOptions[0].value);
  const [pageTitle, setPageTitle] = useState(menuOptions[0].label)
  
  const onChangeMenu = (menu) => {
    const menuLabel = menuOptions.filter((m) => m.value === menu)[0].label
    setSelectedMenu(menu);
    setPageTitle(menuLabel);
  } 

  return (
    <div data-testid="vehicle-status" className="vehicle-status-page">
      <Row justify={"center"} className="mt1 mb1">
        <Col sm={24} md={24} lg={24} xl={22}>
          <div className="vaBaseMargins">
            <VehicleAnalyticsMenu
              menuOptions={menuOptions}
              selectedMenu={selectedMenu}
              onChangeMenu={onChangeMenu}
            />
            <PageLayout
              pageTitle={pageTitle}
              selectedMenu={selectedMenu}
            />
          </div>
      </Col>
      </Row>
    </div>
  );
};

export default VehicleAnalytics;
